import { useBookingNumber } from '@/domain/groups/hooks'
import { useIntl } from '@/intl'
import { CheckoutErrorDialog } from '@/scopes/checkout/components/CheckoutError/CheckoutErrorDialog'
import { useBookingDraftQuery, useCheckoutSidSession } from '@/scopes/checkout/domain/hooks'
import * as React from 'react'

interface CheckoutErrorProps {
  showRedirectButton?: boolean
}

export function CheckoutError({ showRedirectButton = true }: CheckoutErrorProps) {
  const { data } = useBookingDraftQuery()
  const bookingNumber = useBookingNumber()
  const intl = useIntl()
  const { clearDraftId } = useCheckoutSidSession()

  const error = data?.error

  if (!error || (error && !error.hasError))
    return null

  const goToNextStep = () => {
    if (bookingNumber) {
      clearDraftId()
      window.location.href = `${error.redirectUrl}?bookingNumber=${bookingNumber}`
    }
    else {
      window.location.href = error.redirectUrl
    }
  }

  const buttonData = showRedirectButton
    ? {
        text: intl.formatMessage({ id: `checkout_steps_error_go_to_${error.redirectTo}_button_text` }),
        onClick: goToNextStep,
      }
    : undefined

  return <CheckoutErrorDialog buttonData={buttonData} />
}
